import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ISave } from './models/i-save.model';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private onSaveList: ISave[] = [];
  private needsSave$ = new BehaviorSubject(false);

  public getNeedsSave() {
    return this.needsSave$.asObservable();
  }
  public needsSave(needsSave = true) {
    this.needsSave$.next(needsSave);
  }

  public async saveSettings() {
    for (const saver of this.onSaveList) {
      await saver.onSave();
    }
    this.onSaveList = [];

    this.needsSave(false);
  }

  public onSave(saver: ISave) {
    if (!this.onSaveList.includes(saver)) {
      this.onSaveList.push(saver);
    }
  }
}
